import { useState } from "react";
import api, { fmtIDR, apiErr } from "@/lib/api";
import { DateInput, fmtDate } from "@/components/DateInput";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Gift } from "lucide-react";

const lastDay = (y, m) => new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10);

export function ThrDialog({ clientId, year, month, selected = [], disabled, onDone }) {
  const [open, setOpen] = useState(false);
  const [ref, setRef] = useState(lastDay(year, month));
  const [basis, setBasis] = useState("base_fixed");
  const [res, setRes] = useState(null);
  const run = async () => {
    try {
      const { data } = await api.post("/payroll/thr-auto", { client_id: clientId, year, month, ref_date: ref, basis, ids: selected.length ? selected : null });
      setRes(data); toast.success(`THR ${data.updated} karyawan dihitung & masuk ke periode ini`); onDone();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <>
      <Button size="sm" variant="outline" disabled={disabled} onClick={() => { setRes(null); setRef(lastDay(year, month)); setOpen(true); }} data-testid="monthly-thr-btn"><Gift className="h-4 w-4 mr-1" />Hitung THR Otomatis</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-auto">
          <DialogHeader><DialogTitle>Hitung THR Otomatis</DialogTitle>
            <DialogDescription className="text-xs">Sesuai Permenaker 6/2016: masa kerja ≥ 12 bulan = 1 bulan upah; 1–11 bulan = masa kerja ÷ 12 × upah; &lt; 1 bulan = tidak dapat. Masa kerja dihitung dari Tanggal Masuk karyawan (kosong = dianggap ≥ 12 bulan). THR ditambahkan ke kolom THR periode ini dan ikut dihitung PPh 21. {selected.length ? `Hanya ${selected.length} karyawan terpilih.` : "Semua karyawan di periode ini."}</DialogDescription></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label className="text-xs">Tanggal hari raya / acuan masa kerja</Label><DateInput value={ref} onChange={(e) => setRef(e.target.value)} data-testid="thr-ref-date" /></div>
            <div className="space-y-1.5"><Label className="text-xs">Dasar upah THR</Label>
              <Select value={basis} onValueChange={setBasis}>
                <SelectTrigger data-testid="thr-basis"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="base_fixed">Gaji Pokok + Tunjangan Tetap</SelectItem><SelectItem value="base">Gaji Pokok saja</SelectItem></SelectContent>
              </Select></div>
          </div>
          {res && (
            <div className="overflow-auto rounded-md border border-border max-h-72" data-testid="thr-result">
              <Table>
                <TableHeader><TableRow className="bg-secondary/50"><TableHead>Karyawan</TableHead><TableHead>Tgl Masuk</TableHead><TableHead className="text-right">Masa Kerja</TableHead><TableHead className="text-right">Upah</TableHead><TableHead className="text-right">THR</TableHead></TableRow></TableHeader>
                <TableBody>{res.items.map((i) => (
                  <TableRow key={i.id}><TableCell className="text-xs">{i.name}</TableCell><TableCell className="num text-xs">{i.join_date ? fmtDate(i.join_date) : "—"}</TableCell>
                    <TableCell className="num text-right text-xs">{i.months} bln</TableCell><TableCell className="num text-right text-xs">{fmtIDR(i.wage)}</TableCell>
                    <TableCell className="num text-right text-xs font-semibold" data-testid={`thr-amount-${i.id}`}>{fmtIDR(i.thr)}</TableCell></TableRow>))}</TableBody>
              </Table>
            </div>
          )}
          <DialogFooter><Button onClick={run} data-testid="thr-run">Hitung & Masukkan THR</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
